import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';
import { unwrapElement } from '@oracle/oraclejet-testing/UNSAFE_Driver';

export class SelectSingleAdapter extends TestAdapter {
  /**
   * Change and commit the value of the component.
   * @param value {string | number | undefined} The new value.
   * @returns Promise<void>
   */
  async changeValue(value: string | number | undefined) {
    const driver = this.getTestDriver();
    const el = await this.getElement();
    // Scripts can only reference local variables.
    const newValue = value;

    // For now, unwrap the TestElement to get the underlying DOM element until JET-73740 is fixed.
    await driver.executeScript(
      /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
      (el: any, newValue: string | number | undefined) => el._changeValue(newValue),
      unwrapElement(el),
      newValue
    );
  }

  /**
   * Clear the value of the component.
   * @returns Promise<void>
   */
  async clear() {
    await this.changeValue(undefined);
  }
}
